module.exports = __webpack_public_path__ + "img/0025.fb630e92.gif";